

import { CollectionUtils } from '~src/Collections/utils/CollectionUtils';

import { Messages } from '../../../../codegen/Localize';
import { openManageItemsInCollectionsDialogAction } from '../../../../Collections/actions/ManageItemsInCollectionAction';
import { MAX_ITEMS_PER_COLLECTION } from '../../../../Collections/space/ManageItemsInCollectionsDialog';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource, anyItemIsUnpublishedWorkbook, isSingleUnpublishedFlowDraft } from './IEntityActionHelpers';

export const OpenManageItemsInCollectionsDialogEntityAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.AddToCollections,
  translateName: Messages.addToCollections,
  isVisible: (targetItems: IContentInfo[]) => {
    return CollectionUtils.checkCollectionSiteSetting() && targetItems.length > 0 && !anyItemIsEmbeddedDatasource(targetItems) && !isSingleUnpublishedFlowDraft(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo[]) => {
    if (anyItemIsUnpublishedWorkbook(targetItems)) {
      return false;
    }

    return targetItems.length <= MAX_ITEMS_PER_COLLECTION;
  },
  createReduxAction: (targetItems: IContentInfo[]) => openManageItemsInCollectionsDialogAction(targetItems)
};
